import { module } from 'angular';
import RepreComponent from './repre.component';
import './repre.scss';
import RepreService from './model/repre.service';

export default module('app')
	.component('repre', RepreComponent)
	.service('RepreService', RepreService)
	.name;
